import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";

const ALLOWED = ["p", "strong", "em", "h1", "h2", "h3", "ul", "ol", "li", "br"];

const components = {
  h1: (p) => <h3 className="font-display text-3xl font-black tracking-tight not-italic mt-6 mb-2" {...p} />,
  h2: (p) => <h3 className="font-display text-2xl font-bold tracking-tight not-italic mt-6 mb-2" {...p} />,
  h3: (p) => <h4 className="font-display text-xl font-bold tracking-tight not-italic mt-5 mb-2" {...p} />,
  p: (p) => <p className="mb-4 last:mb-0" {...p} />,
  strong: (p) => <strong className="font-bold text-white" {...p} />,
  ul: (p) => <ul className="list-disc pl-6 mb-4 space-y-1" {...p} />,
  ol: (p) => <ol className="list-decimal pl-6 mb-4 space-y-1" {...p} />,
};

export default function BioView({ text, className = "", testId }) {
  return (
    <div className={`break-words ${className}`} data-testid={testId}>
      <ReactMarkdown remarkPlugins={[remarkBreaks]} allowedElements={ALLOWED} unwrapDisallowed skipHtml components={components}>
        {text || ""}
      </ReactMarkdown>
    </div>
  );
}
